import React from "react"
import styled from "styled-components"
import Link from "./Link"
import { theme } from "Theme"

const StyledLink = styled((props) => <Link {...props} />)`
  cursor: pointer;
  align-items: center;
  padding: 0;
  margin: 0;
  span {
    display: block;
  }
  border-radius: ${theme.borderRadius.ui};
`
const StyledBox =styled.div`
/* cursor: pointer; */
align-items: center;
padding: 0;
margin: 0;
span {
  display: block;
}
border-radius: ${theme.borderRadius.ui};
`
const LinkBox = ({ children, to, target, track, title, ...other }) => (
  <StyledBox to={to} track={track} title={title} target={target} {...other}>
    {children}
  </StyledBox>
)

export default LinkBox
